//eventDetail.js
import request from '@/utils/request';

export function getEventDetail(forum_id) {
  return request({
    url: '/v1/forum_info/' + forum_id,
    method: 'get',
  });
}
